export const resetPaginationToFirstPage = <T extends { current: number }>(
  pagination: T,
): T => ({
  ...pagination,
  current: 1,
});
